var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-layout p-layout--default u-typography-root",style:(_vm.rootStyles)},[_c('nuxt'),_vm._v(" "),_c('main-menu'),_vm._v(" "),_c('overlay-root',{staticClass:"u-typography-root"}),_vm._v(" "),_c('client-only',[_c('scroll-observer'),_vm._v(" "),_c('viewport-observer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }